module.exports = __webpack_public_path__ + "static/opportunity-5f93af7b5016b8b312509d88cb46afa8.svg";